import SettingsSMSCard from './SettingsSMSCard';

export default SettingsSMSCard;
